import React from 'react';
import classNames from 'classnames';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

import InDemandJobsList from 'components/jobs/list/InDemandJobsList';
import DemographicChart from 'layouts/salaryJobPage/salaryDemographics/DemographicCart.jsx';
import { formatCurrency, formatEducationLabel } from 'utils';

import ChartTable from '../chartTable';
import GenderEthnicLanguageDiversity from '../GenderEthnicLanguageDiversity';
import RaceEthnicity from '../RaceEthnicity';

import classes from './index.module.css';

const ethnicityHead = [
  { title: 'Ethnicity', value: 'ethnicity' },
  { title: 'Salary', value: 'salary' },
];

const RaceStatistics = ({
  jobTitle,
  raceEthnicitiesOverTime,
  ethnicityOverTimeContentBlurb,
  salaryEstimates,
  ethnicityIncomeBlurb,
  ethnicityPieChart,
  ethnicitySectionContentBlurb,
  filterLogEventCallback,
  filterValueRange,
  isDesktop,
  inDemandJobs,
}) => {
  const getTableData = (tableRowData = {}, columnName1, columnName2) => {
    return Object.keys(tableRowData).map((key) => ({
      [columnName1]: formatEducationLabel(key),
      [columnName2]: tableRowData[key],
    }));
  };

  return (
    <section
      id="race-statistics"
      className={classNames(classes.fullWidthContainer, 'position-relative', 'w-730')}
    >
      {isDesktop === true && <div className="section-separator-large" />}

      <h2 className="brandonH2 w-730 z-mb-48">{`${jobTitle} Statistics By Race`}</h2>
      <div className="d-flex justify-content-between flex-column flex-lg-row">
        <div className={classNames(classes.raceStatisticsContainer, 'w-730')}>
          {ethnicityPieChart && (
            <>
              <GenderEthnicLanguageDiversity
                jobTitle={jobTitle}
                ethnicitySetionContentBlurb={ethnicitySectionContentBlurb}
                pieChartData={[ethnicityPieChart]}
                filterLogEventCallback={filterLogEventCallback}
                filterValueRange={filterValueRange}
                noTitle
              />
              <div className="section-separator-medium"></div>
            </>
          )}

          {raceEthnicitiesOverTime && (
            <>
              <RaceEthnicity
                jobTitle={jobTitle}
                raceEthnicitiesOverTime={raceEthnicitiesOverTime}
                ethnicityOverTimeContentBlurb={ethnicityOverTimeContentBlurb}
              />
              <div className="section-separator-medium" />
            </>
          )}

          {salaryEstimates && salaryEstimates.byEthnicity && (
            <div className={classes.salaryDemographicChart}>
              <h3 className="cmpSectionh4">{`${jobTitle} Wage Gap By Race`}</h3>
              {ethnicityIncomeBlurb && (
                <div
                  className="mt-3"
                  dangerouslySetInnerHTML={{ __html: ethnicityIncomeBlurb.content }}
                />
              )}
              <div className="mt-5">
                <div className="d-none d-md-block">
                  <DemographicChart
                    xLabels={Object.keys(salaryEstimates.byEthnicity)}
                    values={Object.values(salaryEstimates.byEthnicity)}
                  />
                </div>
                <div className="d-block d-md-none">
                  <ChartTable
                    heads={ethnicityHead}
                    tableData={getTableData(salaryEstimates.byEthnicity, 'ethnicity', 'salary')}
                    defaultSortedColumn="salary"
                    formatter={formatCurrency}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
        {(salaryEstimates?.byEthnicity || raceEthnicitiesOverTime || ethnicityPieChart) &&
          !!inDemandJobs?.length && (
            <div className="job-list-placeholder">
              <InDemandJobsList inDemandJobs={inDemandJobs} title="Browse Most In Demand Jobs" />
            </div>
          )}
      </div>
    </section>
  );
};

export default RaceStatistics;
